import { formFieldsConfigProcessed } from "./config/ProductInformationConfig";
import { formFieldsState } from "./state/ProductInformationState";
import { formFieldsValidation } from "./validations/ProductInformationValidations";
import { PRODUCT_INFORMATION_CONSTANTS } from "../../constants";

export const formName = PRODUCT_INFORMATION_CONSTANTS.FORM_NAME;
export const formState = formFieldsState;
export const formConfig = formFieldsConfigProcessed;
export const formValidation = formFieldsValidation;

export { formFieldsConfigProcessed, formFieldsState, formFieldsValidation };
